import styled from 'styled-components';
export const VolumeContainer = styled.div `
    display: flex;
    position: relative;
    line-height: 0;
    width: 136;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    column-gap: 12;
`;
//# sourceMappingURL=index.js.map